import {
    FetchWorkflowLogsParams,
    FetchWorkflowStepsParams,
    FetchWorkflowsParams,
} from 'api/workflows';
import { accountQueryKeys } from 'queries/account-query-keys';

const workflowQueryKeys = {
    workflows: (accountId: number) => [...accountQueryKeys.current(accountId), 'workflows'],
    workflowsWithFilters: (accountId: number, params: FetchWorkflowsParams = {}) => [
        ...workflowQueryKeys.workflows(accountId),
        params,
    ],
    workflowById: (accountId: number, workflowId: number) => [
        ...workflowQueryKeys.workflows(accountId),
        workflowId,
    ],
    workflowStepsById: (accountId: number, workflowId: number) => [
        ...workflowQueryKeys.workflowById(accountId, workflowId),
        'steps',
    ],
    workflowStepsByIdWithFilters: (
        accountId: number,
        workflowId: number,
        params: FetchWorkflowStepsParams,
    ) => [...workflowQueryKeys.workflowStepsById(accountId, workflowId), params],

    workflowLogs: (accountId: number) => [
        ...workflowQueryKeys.workflows(accountId),
        'workflowLogs',
    ],
    workflowLogsById: (accountId: number, workflowId: number) => [
        ...workflowQueryKeys.workflowLogs(accountId),
        workflowId,
    ],
    workflowLogsWithFilters: (
        accountId: number,
        workflowId: number,
        params: FetchWorkflowLogsParams,
    ) => [...workflowQueryKeys.workflowLogsById(accountId, workflowId), params],

    workflowUsage: (accountId: number) => [
        ...workflowQueryKeys.workflows(accountId),
        'workflowUsage',
    ],
    workflowUsageById: (accountId: number, workflowId: number) => [
        ...workflowQueryKeys.workflowUsage(accountId),
        workflowId,
    ],
    workflowActionMetrics: (accountId: number) => [
        ...workflowQueryKeys.workflows(accountId),
        'workflowActionMetrics',
    ],
    workflowActionMetricsById: (accountId: number, workflowId: number) => [
        ...workflowQueryKeys.workflowActionMetrics(accountId),
        workflowId,
    ],
    workflowMetrics: (accountId: number) => [
        ...workflowQueryKeys.workflows(accountId),
        'workflowMetrics',
    ],
    workflowMetricsById: (accountId: number, workflowId: number) => [
        ...workflowQueryKeys.workflowMetrics(accountId),
        workflowId,
    ],
};

const workflowMutationKeys = {
    workflows: () => ['workflows'],
    workflowAutoSave: () => [...workflowMutationKeys.workflows(), 'autosave'],
};

export { workflowQueryKeys, workflowMutationKeys };
